export const capitalizeFirstLetter = (word)=>`${word[0].toUpperCase()}${word.slice(1)}`;
export const capitalizeFirstLetterOfEachWord = (word)=>word.split('-').map((wordValue)=>capitalizeFirstLetter(wordValue)).join('-');
